<template>
        <div class="container">
            <div class="columns is-mobile">
                <div class="column">
                    <p class="player">Player 1</p>
                    <span class="score">{{ scores.player_one }}</span>
                </div>
                <div class="column">
                    <p class="player">Player 2</p>
                    <span class="score">{{ scores.player_two }}</span>
                </div>
                <div class="column">
                    <p class="player">Player 3</p>
                    <span class="score">{{ scores.player_three }}</span>
                </div>
                <div class="column">
                    <p class="player">Player 4</p>
                    <span class="score">{{ scores.player_four }}</span>
                </div>
            </div>
        </div>
</template>

<script>
    export default {
        name: "Scores",
        props: ['scores']
    }
</script>

<style lang="scss" scoped>
    .container { padding: 10px 20px; }
    .player {
        font-weight: bold;
        color: #a1e0be;
        font-size: 0.9em;
    }
    .score {
        display: inline-block;
        font-size: 1.2em;
        padding: 10px 20px;
        color: white;
        font-weight: bold;
    }
</style>